module.exports = __webpack_public_path__ + "static/media/poster_1.6e489293.png";